import { useEffect, useMemo, useState } from "react";
import { fetchSignedVideos } from "../utils/videoApi";

/**
 * Carrega vídeos assinados para o avatar/path informado.
 */
export function useSignedVideos(avatarPath, options = {}) {
  const [videoUrls, setVideoUrls] = useState({});

  const aliasesDep = useMemo(() => JSON.stringify(options?.aliases || {}), [options?.aliases]);
  const keysDep = useMemo(
    () => JSON.stringify(Array.isArray(options?.keys) ? [...options.keys].sort() : []),
    [options?.keys]
  );

  const aliases = useMemo(() => JSON.parse(aliasesDep), [aliasesDep]);
  const keys = useMemo(() => JSON.parse(keysDep), [keysDep]);

  useEffect(() => {
    let isMounted = true;
    const load = async () => {
      const videos = await fetchSignedVideos(avatarPath, aliases, { keys });
      if (!isMounted) return;
      setVideoUrls(videos);
    };
    if (avatarPath) load();
    return () => {
      isMounted = false;
    };
  }, [avatarPath, aliasesDep, keysDep, aliases, keys]);

  return videoUrls;
}
